import { EventBus } from '@/plugins/event-bus'

const moduleState = {
  stockcarsNew: [],
  isLoading: false,
}

const getters = {
  stockcars: (state) => state.stockcarsNew,
}

const mutations = {
  setStockCars: (state, payload) => {
    state.stockcarsNew = payload
    EventBus.$emit('stockcarsNew/stockcars')
  },
  resetStockCars: (state) => {
    state.stockcarsNew = []
    EventBus.$emit('stockcarsNew/stockcars')
  },
}

const actions = {
  async reset({ commit }) {
    commit('resetStockCars')
  },
  async addStockCars({ commit, state }, payload) {
    const noDuplicates = payload.filter(
      (existingStockCar) =>
        !state.stockcarsNew.some(
          (newStockCar) =>
            newStockCar.Brand === existingStockCar.Brand &&
            newStockCar.CommissionNumber === existingStockCar.CommissionNumber &&
            newStockCar.CommissionYear === existingStockCar.CommissionYear
        )
    )
    commit('setStockCars', state.stockcarsNew.concat(noDuplicates))
  },
}

export default {
  state: moduleState,
  getters,
  mutations,
  actions,
  namespaced: true,
}
